import { render, staticRenderFns } from "./ThemedComponent.vue?vue&type=template&id=8be01dac&scoped=true"
import script from "./ThemedComponent.vue?vue&type=script&lang=js"
export * from "./ThemedComponent.vue?vue&type=script&lang=js"
import style0 from "./ThemedComponent.vue?vue&type=style&index=0&id=8be01dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be01dac",
  null
  
)

export default component.exports